import { changePassword } from "../../features/profileSlice";
import { logOut } from "../../features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { Container, Form, Button, Toast } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import '../../static/css/App.css';

library.add(fas, fab, far);

function ChangePassword() {
    const dispatch = useDispatch();
    const [toastShow, setToastShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const [toastKey, setToastKey] = useState(0);

    const [updatePassword, setUpdatePassword] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    const { updateState, error } = useSelector((state) => state.profile);

    // Always show toast, even if the error is the same
    const showToast = (message, variant = "success") => {
        setToastMessage(message);
        setToastVariant(variant);
        setToastShow(false); // Hide first to force a remount
        setTimeout(() => {
            setToastShow(true);
            setToastKey(prev => prev + 1);
        }, 30);
    };

    const handleChangePassword = () => {
        const { newPassword, confirmPassword } = updatePassword;

        if (newPassword.trim() === "") {
            showToast("New password cannot be empty.", "danger");
        } else if (newPassword.length < 6) {
            showToast("New password must be at least 6 characters.", "danger");
        } else if (newPassword !== confirmPassword) {
            showToast("Confirm password does not match.", "danger");
        } else {
            dispatch(changePassword(updatePassword));
        }
    };

    const handleInputValue = (e) => {
        setUpdatePassword({
            ...updatePassword,
            [e.target.name]: e.target.value
        });
    };

    // On password update, show toast and log out after delay
    useEffect(() => {
        if (updateState) {
            showToast("Password changed successfully. You have been logged out.", "success");
            setTimeout(() => {
                dispatch(logOut());
            }, 2000);
        }
    }, [updateState, dispatch]); // include dispatch in deps

    // Show error toast if error state changes
    useEffect(() => {
        if (error && error !== "") {
            showToast(error, "danger");
        }
    }, [error]);

    return (
        <div>
            <Container fluid>
                <Toast
                    key={toastKey}
                    onClose={() => setToastShow(false)}
                    show={toastShow}
                    delay={3000}
                    autohide
                    bg={toastVariant}
                    style={{
                        position: 'fixed',
                        top: 20,
                        right: 20,
                        zIndex: 9999
                    }}
                >
                    <Toast.Body className="text-white text-center fw-bold">
                        {toastMessage}
                    </Toast.Body>
                </Toast>

                <Form className="col-12 col-sm-6 m-auto">
                    <Form.Group className="mb-3" controlId="formOldPassword">
                        <Form.Label>Current Password</Form.Label>
                        <Form.Control
                            placeholder="Current Password"
                            type="password"
                            name="oldPassword"
                            onChange={handleInputValue}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formNewPassword">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                            placeholder="New Password"
                            type="password"
                            name="newPassword"
                            onChange={handleInputValue}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formConfirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                            placeholder="Confirm Password"
                            type="password"
                            name="confirmPassword"
                            onChange={handleInputValue}
                        />
                    </Form.Group>

                    <Button
                        variant="primary"
                        className="d-block m-auto"
                        onClick={handleChangePassword}
                    >
                        Update Profile
                    </Button>
                </Form>
            </Container>
        </div>
    );
}

export default ChangePassword;
